module.exports = __webpack_public_path__ + "static/bg-cisco-ba9a9cc753d037bc67f6c246c606a5f2.webp";